import orange from '@material-ui/core/colors/orange';
import blue from '@material-ui/core/colors/blue';
import red from '@material-ui/core/colors/red';
import cyan from '@material-ui/core/colors/cyan';
import green from '@material-ui/core/colors/green';
import { makeStyles } from '@material-ui/styles';

const ProspectStatusEnum = {
  Submitted: 'Submitted',
  ActiveUnderwrite: 'Active Underwrite',
  ActiveOffer: 'Active Offer',
  UnderContractContingent: 'Under Contract - Contingent',
  UnderContractApproved: 'Under Contract - Approved',
  Closed: 'Closed',
  Rejected: 'Rejected'
};

export const submittedColor = orange[800];
export const underContractContingentColor = blue[800];
export const underContractApprovedColor = blue[300];
export const rejectedColor = red[800];
export const activeUnderwriteColor = cyan[800];
export const closedColor = green[600];
export const activeOfferColor = cyan[300];
/**
 * IMPORTANT:must be in sync with prospector
 */
export const getStatusChipStyles = makeStyles({
  submitted: {
    backgroundColor: `${submittedColor} !important`
  },
  underContractContingent: {
    backgroundColor: `${underContractContingentColor} !important`
  },
  underContractApproved: {
    backgroundColor: `${underContractApprovedColor} !important`
  },
  rejected: {
    backgroundColor: `${rejectedColor} !important`
  },
  activeUnderwrite: {
    backgroundColor: `${activeUnderwriteColor} !important`
  },
  activeOffer: {
    backgroundColor: `${activeOfferColor} !important`
  },
  closed: {
    backgroundColor: `${closedColor} !important`
  }
});

export function getStatusChipClass(status) {
  const classes = getStatusChipStyles();
  switch (status) {
    case ProspectStatusEnum.Submitted:
      return classes.submitted;
    case ProspectStatusEnum.UnderContractContingent:
      return classes.underContractContingent;
    case ProspectStatusEnum.UnderContractApproved:
      return classes.underContractApproved;
    case ProspectStatusEnum.Rejected:
      return classes.rejected;
    case ProspectStatusEnum.ActiveUnderwrite:
      return classes.activeUnderwrite;
    case ProspectStatusEnum.ActiveOffer:
      return classes.activeOffer;
    case ProspectStatusEnum.Closed:
      return classes.closed;
    default:
  }
}
